import { useEffect, useState } from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import Button from "@amzn/awsui-components-react/polaris/button";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Input from "@amzn/awsui-components-react/polaris/input";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { useMarketplaceSelector } from "../../components/MarketplaceSelector";
import useQueryMerchantConfiguration from "../../Api/useQueryMerchantConfiguration";
import Alert from "@amzn/awsui-components-react/polaris/alert";
import MerchantConfigurationPageResult from "./merchantConfigurationPageResult";
import { isNullOrUndefinedOrEmpty } from "../../utils/formatUtils";
import { Toggle } from "@amzn/awsui-components-react";

const MerchantConfigurationPage = () => {
  const { marketplace, MarketplaceSelector } = useMarketplaceSelector(null);
  const [merchantId, setMerchantId] = useState("");
  const [hasMerchant, setHasMerchant] = useState(true);

  useEffect(() => {
    if (!hasMerchant) {
      setMerchantId("");
    }
  }, [hasMerchant]);

  const {
    isFetching,
    error,
    data: merchantConfigurationResponse,
    refetch,
  } = useQueryMerchantConfiguration({ marketplace, merchantId });

  const handleSubmit = () => {
    if (isNullOrUndefinedOrEmpty(marketplace)) {
      return;
    }
    refetch();
  };

  return (
    <SpaceBetween direction="vertical" size="xxl">
      <Container
        header={<Header variant="h2">Configuration Details</Header>}
        footer={
          <Button variant="primary" loading={isFetching} onClick={handleSubmit}>
            Get IBA Configured Merchant
          </Button>
        }
      >
        <SpaceBetween direction="vertical" size="m">
          <FormField label="Marketplace ID" stretch>
            <MarketplaceSelector />
          </FormField>
          <FormField label="Do you have a merchant?" description="If not, one will be aquired automatically" stretch>
            <Toggle checked={hasMerchant} onChange={({ detail }) => setHasMerchant(detail.checked)}>
              {hasMerchant ? "Yes" : "No"}
            </Toggle>
          </FormField>
          <FormField label="Merchant ID" stretch>
            <Input
              value={merchantId}
              onChange={({ detail }) => setMerchantId(detail.value)}
              placeholder="Enter Merchant ID"
              disabled={!hasMerchant}
            />
          </FormField>
        </SpaceBetween>
      </Container>
      {error && <Alert type="error">{error}</Alert>}
      {merchantConfigurationResponse && <MerchantConfigurationPageResult response={merchantConfigurationResponse} />}
    </SpaceBetween>
  );
};

export default MerchantConfigurationPage;
